/** @format */

import { Avatar } from "antd";
import React from "react";
import { avatarColorOf, fullNameOf, initialsOf } from "../utils/people";

interface Props {
  person: {
    name?: string | null;
    surname?: string | null;
    avatar_storage_url?: string | null;
    has_avatar?: boolean;
  };
  size?: number;
  className?: string;
}

/** Foto profilo se presente, altrimenti iniziali su colore stabile. */
export const OrgAvatar = ({ person, size = 32, className }: Props): JSX.Element => (
  <Avatar
    size={size}
    className={className}
    src={person.has_avatar && person.avatar_storage_url ? person.avatar_storage_url : undefined}
    style={{
      backgroundColor: avatarColorOf(fullNameOf(person)),
      flex: "none",
      fontSize: Math.round(size * 0.38),
      fontWeight: 600,
    }}
  >
    {initialsOf(person)}
  </Avatar>
);
